const userAssociateType = {
  DEPOT: 'DEPOT',
  GATE: 'GATE',
  MATERIAL: 'MATERIAL',
  INDENT: 'INDENT',
};
const totalCount = {
  AllowedUsersCount: 10,
};
const userAssociateErrors = {
  ERR_INVALID_MAT_CODE: 'Invalid material code',
  ERR_TOTAL_USER_COUNT: 'Total user count is more than',
  ERR_INVALID_EMAILS: 'Invalid email ids -',
  ERR_INVALID_ROLES: 'Invalid roles for email ids -',
};

module.exports = { userAssociateType, totalCount, userAssociateErrors };
